import HttpClient from "../HttpClient";

export default class CampaignService {
    async postCampaign(payload: any){
        const res = await HttpClient.post(`/v1/customer/ad-campaign`, payload);
        return res?.data;
    }

}
